import { useTranslation } from 'react-i18next'

import { Alert, ComboBox, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { locationListTypeValues } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

import useValidateUrl from '../hooks/useValidateUrl/useValidateUrl'
import { locationListTypeOptions } from './constants'
import * as Styles from './styles'

const ReturnToStoreMethod = ({ config, onChange }) => {
  const { t } = useTranslation()
  const { error, validateUrl } = useValidateUrl()

  const handleChangeShopsUrl = e => {
    onChange({ url: e.target.value })
    validateUrl(e.target.value)
  }

  const handleChangeLocationListType = e => {
    onChange({ location_list_type: e.target.value })
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Entrega de productos')}</Text>
      <Text type="bodyMRegular">
        {t('Define cuales serán las tiendas que se le mostrarán a los clientes para que entreguen los productos.')}
      </Text>
      <Styles.SelectorsContainer>
        <ComboBox
          label={t('Mostrar tiendas definidas en')}
          menuItems={locationListTypeOptions.map(o => ({ ...o, label: t(o.label) }))}
          handleChange={handleChangeLocationListType}
          value={config?.location_list_type}
        />
        {config?.location_list_type === locationListTypeValues.url && (
          <InputWithLabel
            label={t('URL listado tiendas')}
            fullWidth
            value={config?.url}
            error={error}
            helperText={error}
            onChange={handleChangeShopsUrl}
          />
        )}
        {config?.location_list_type === locationListTypeValues.locations && (
          <Alert type="info">
            {t(
              'Al cliente se le mostrarán Ubicaciones de tipo “Tienda” en base a la región desde la que quiere hacer su devolución'
            )}
          </Alert>
        )}
      </Styles.SelectorsContainer>
    </Styles.Container>
  )
}

export default ReturnToStoreMethod
